import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variable-allowance-form',
  templateUrl: './variable-allowance-form.component.html',
  styleUrls: ['./variable-allowance-form.component.css']
})
export class VariableAllowanceFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-form/variable-allowance-form.component.ts